export default {
  EquipmentInventoryItemList: {
    EquipmentInventoryItem: 'Công cụ dụng cụ',
    DictionaryEquipmentInventoryItemt: '/ Kho / Công cụ dụng cụ',
    Dictionary: 'Danh mục',
    IncrementCCDC: 'Ghi tăng CCDC',
    DecrementCCDC: 'Ghi giảm CCDC',
  },
  EquipmentInventoryItemDetail: {
    Text: {
      InventoryItemCode: 'Mã CCDC *',
      InventoryItemName: 'Tên CCDC *',
      IsTool: 'Là loại công cụ dụng cụ',
      Unit: 'Đơn vị tính',
      UnitPrice: 'Đơn giá',
      Description: 'Diễn giải',
    },
    TextToolTip: {
      InventoryItemCode: 'Mã loại công cụ dụng cụ',
      InventoryItemName: 'Tên loại công cụ dụng cụ',
    },
    Combobox: {
      Text: {
        InventoryCategory: 'Loại vật tư/CCDC *',
        Stock: 'Kho *',
      },
      TextToolTip: {
        InventoryCategory: 'Loại vật tư, công cụ dụng cụ',
        Stock: 'Kho',
      },
    },
  },
};
